exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-447e9e6e]{grid-area:CL;display:flex;flex-direction:column;padding:24px 10px 0 16px;background:var(--secondary)}.category[data-v-447e9e6e]{display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;color:var(--grey);font-size:12px;font-weight:500;text-transform:uppercase}.category .category-icon[data-v-447e9e6e]{color:var(--symbol);cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-447e9e6e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Channel-List/index.vue
// module id = 53
// module chunks = 0